import { render, staticRenderFns } from "./gongbao.vue?vue&type=template&id=9e9a1d64&"
import script from "./gongbao.vue?vue&type=script&lang=js&"
export * from "./gongbao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports